import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Component that attaches scroll-to-top behavior on route change
function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // Only scroll to top if there is no hash in the URL
    if (!hash) {
      // Scroll to top
      window.scrollTo({
      top: 0,
      left: 0,
      });
    } else {
      // If there is a hash, wait for the page to load then scroll to the hash
      setTimeout(() => {
        const id = hash.substring(1); // Get ID without the # character
        const element = document.getElementById(id);
        if (element) {
          // Using a smaller offset for philosophy and standard offsets for others
          const offsets: Record<string, number> = {
            'philosophy': 40,     // Reduced offset for philosophy to scroll less
            'coreValues': 80,     // Keep the same offset
            'journey': 80         // Keep the same offset
          };
          
          // Get the appropriate offset for the section or use default
          const headerOffset = offsets[id] || 80;
          
          // Calculate position with offset
          const elementPosition = element.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
          
          // Smooth scroll to element with offset
          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }
      }, 300);
    }
  }, [pathname, hash]); // Trigger effect when pathname or hash changes

  return null; // This component does not render anything
}

export default ScrollToTop; 